/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS = 'TabbedPartnerContainerBlock';
const CLS = 'tabbedPartnerContainerBlock';
const WG = '.' + CLS + '-';
const CLS_IS_ACTIVE = 'is-active';
const CLS_HIDE = 'd-none';

import _ from 'lodash';
import utils from '../utils';


export class TabbedPartnerContainerBlock {
	constructor($el) {
		// $el is the widget node return by the loadTabbedPartnerContainerBlock function
		this.$el = $el;
	}

	init() {
		this.setTabbedPartnerContainerBlock();
		this.renderDropdown();
		this.setDropdownMobile();
		this.setId();
	}

	setTabbedPartnerContainerBlock() {
		const This = this;
		const $wg = $(this.$el);
		let tabsBtns = $wg.find('.tab-title');

		if (tabsBtns.length > 2) {
			$wg.addClass(`${CLS}--tabs${tabsBtns.length}`);
		}

		tabsBtns.on('click', function() {
			This.showPartner($(this).data('id'));
		});
	}

	setId() {
		const $wg = $(this.$el);
		let tabs = $wg.find('.partnerItemBlock');
		let tabsBtns = $wg.find('.tab-title');
		let dropdownItem = $wg.find(WG + 'dropdown .dropdown-item');

		_.forEach(tabs, function(tab, index) {
			let idx = CLS + '-trigger-' + utils.generateRandomId();
			$(tab).attr('data-id', idx);
			$(tabsBtns[index]).attr('data-id', idx);
			$(dropdownItem[index]).attr('data-id', idx);
		});
	}

	showPartner(id) {
		const $wg = $(this.$el);
		let $selectedTabTitle = $wg.find('.tab-title[data-id="' + id + '"]');
		let $selectedTab = $wg.find('.partnerItemBlock[data-id="' + id + '"]');
		let $selectedDropdownItem = $wg.find(WG + 'dropdown .dropdown-item[data-id="' + id + '"]');
		let $dropdownBtn = $wg.find(WG + 'dropdown .dropdown-toggle');

		$wg.find('.tab-title').removeClass(CLS_IS_ACTIVE);
		$selectedTabTitle.addClass(CLS_IS_ACTIVE);

		$wg.find(WG + 'dropdown .dropdown-item').removeClass(CLS_IS_ACTIVE);
		$selectedDropdownItem.addClass(CLS_IS_ACTIVE);
		$dropdownBtn.html($selectedDropdownItem.html());

		$wg.find('.partnerItemBlock').addClass(CLS_HIDE).hide(0);
		$selectedTab.fadeIn('fast').removeClass(CLS_HIDE);
	}

	setDropdownMobile() {
		const This = this;
		const $wg = $(this.$el);
		let $tabTite = $wg.find(`${WG}tabsHeaders .tab-title`);

		// AM-177: check if only 1 tab, don't need dropdown on mobile
		if ($tabTite.length === 1) {
			$wg.find(WG + 'dropdown').addClass(CLS_HIDE);
			$tabTite.addClass('d-inline-block');
			return;
		}

		let $dropdownBtn = $wg.find(WG + 'dropdown .dropdown-toggle');
		let $dropdownItem = $wg.find(WG + 'dropdown .dropdown-item');
		let $selectedDropdownItem = $wg.find(WG + 'dropdown .dropdown-item.is-active');

		$dropdownBtn.html($selectedDropdownItem.html());

		$dropdownItem.on('click', function() {
			let $this = $(this);
			This.showPartner($this.data('id'));
		});
	}

	renderDropdown() {
		const $wg = $(this.$el);
		let $tabTitle = $wg.find('.tab-title');
		let itemTmpl = '';

		_.forEach($tabTitle, function(item, index) {
			itemTmpl += `<span class="dropdown-item ${index === 0 ? 'is-active' : ''}">${item.innerHTML}</span>`;
		});

		let tmpl = `
		<div class="${CLS}-dropdown">
			<button class="dropdown-toggle" type="button" data-toggle="dropdown"></button>
			<div class="dropdown-menu">
				${itemTmpl}
			</div>
		</div>`;

		$wg.find(`${WG}tabsHeaders`).prepend(tmpl);
	}
}
